var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.textParts),function(e,idx){return [_c('span',{key:idx},[_vm._v(_vm._s(e))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }